import { Component, OnInit } from '@angular/core';
import { Product , CategoryResponse, Category} from '../products/product';
import { ProductsService } from '../products/products.service';
import { Router } from '@angular/router';
import { ControlsService } from '../controls.service';
import { MatSlideToggleChange } from '@angular/material';
import { map, startWith, filter , tap, mergeMap, switchMap, flatMap, take, mergeAll, combineAll} from 'rxjs/operators';
import { zip } from 'rxjs/observable/zip';
// import 'rxjs/add/operator/mergeMap';
import { from } from 'rxjs/observable/from';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';

import { NavigationEnd } from '@angular/router';
import { SearchService} from '../search.service';
import { ConfigurationService } from '../configuration.service';
import { Configuration } from '../configuration';

import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder
} from '@angular/forms';


import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-tool-bar',
  templateUrl: './tool-bar.component.html',
  styleUrls: ['./tool-bar.component.scss']
})
export class ToolBarComponent implements OnInit {
  hide: Boolean = false;
  topLevelCategories: Category[] = [];
  searchForm: FormGroup;
  allCategories: Category[] = [];
  // Controls
  freeControlValue: Boolean = false;
  recentControlValue: Boolean= false;

  searchControl: FormControl = new FormControl();

  options = [];

  filteredOptions: Observable<any[]>;

  currentcategoryArray: Category[] ;

  shouldDisplay: boolean = true;

  config:Configuration = {};

  id: number;

  constructor(
    private productsService:ProductsService,
    fb: FormBuilder,
    private router: Router,
    private cs: ControlsService,
    private route: ActivatedRoute,
    private search: SearchService,
    private configurationService:ConfigurationService,

  ) {

    this.searchForm = fb.group({
      'search': this.searchControl
    });

    // this.filteredOptions = search.getResultsSubject();
  }

  sortByName(a,b) {
    if (a.title < b.title)
      return -1;
    if (a.title > b.title)
      return 1;
    return 0;
  }




  ngOnInit() {

    // this.configurationService.getConfigurationSubject()
    // .subscribe((config:Configuration)=> {
    //   this.config = config;

    // });

    // Breadcrumbs
    this.router
    .events
    .pipe(
    filter(e => e instanceof NavigationEnd),
    tap(nav => this.currentcategoryArray = null),
    map(() => this.route),
    map(route => {
        if (route.firstChild) {
            route = route.firstChild;
        }
        return route;
    }),
    filter(route => route.outlet === 'primary'),
    switchMap(route => route.params),
    filter((params: any )=> params.id),
    switchMap(p => this.productsService.getCatoriesSingle(+p['id'] )),
    flatMap((foundCategory: Category) => {
      let topLevel: any = {parent_id: foundCategory.id};
      return from(foundCategory.parents).pipe(
          startWith(topLevel),
          filter((parent: any) => +parent.parent_id > 0),
          map((parent:any) => this.productsService.getCatoriesSingle(+parent.parent_id)),
          combineAll()
        );


    })
  )
  .subscribe((params:Category[]) => {
       this.currentcategoryArray = params.reverse();
       this.shouldDisplay = true;
     },
     err => console.error('err',err),
     () => console.log('done loading items'));



    const filterCmd = {};
    this.productsService.getCatories(filterCmd)
    .pipe(
      map((results:{data:Category[]}) => {
        results.data = results.data.sort(this.sortByName);
        return results;
      })
    )
    .subscribe((results: CategoryResponse) => {
      this.allCategories = results.data;
      this.productsService.getCatoriesTopLevel()
      .subscribe(data => this.topLevelCategories = data);

    },
    err => console.error(err),
    () => console.log('done loading services')
  );


  // Search data
zip(
  this.productsService.getAllProductsStatic(),
  this.productsService.getCatories(filterCmd).pipe(
    map((item: any)=>{
      // Maps accross the parent id from first level parebt found, if a sub-category

      if (item.hasOwnProperty('data') && item.data.length){
        item.data.map((cat: any) => {


            if (cat.hasOwnProperty("parents") && cat.parents.length) {
              if (cat.parents[0] && cat.parents[0].parent_id > 0 && cat.parents[0].parent_title) {
                cat.parent_title = cat.parents[0].parent_title;
              }
            }
            return cat;
          }

        )


      }


      return item;
    })
  ), (titles, categories) =>{


    return categories.data.concat(titles.data);
  }

).subscribe((results: any[]) => {


  this.search.loadSearch(results);

    // this.options = results;
  },
  err => console.error(err),
  () => console.log('done loading services')
  );

    this.filteredOptions = this.searchControl.valueChanges
      .pipe(
        startWith(''),
        filter(term => {
        return term.length > 2
        }),
        map(val => {

          return this.search.searchRequest(val)
        })
      );

  }

  // option.toLowerCase().indexOf(val.toLowerCase()) === 0
  filter(val: string): string[] {
    const regex: RegExp = new RegExp(val, 'i');
    return this.options.filter((option: {title: string}) => {
        return regex.test(option.title);
    });
  }

  selectionChange(event: any){
    let val = {
      value:{
      search:event.option.value
    }
  };
    this.onSubmit(val);

  }

  onSubmit(val: any){

    if (val.value && val.value.search ){

      // if parents property then its a category of some kind
      if (val.value.search.hasOwnProperty("parents")) {
        // its a category
        if (val.value.search.parents[0].parent_id > 0) {
          // sub category
          this.router.navigate(
            [
              "products",
              val
                .value
                .search
                .id
            ]
          );
        } else {
          // top level

          this.router.navigate([
            "category",
            val.value.search.id
          ]);
        }
      } else if (typeof val.value.search == "string") {
        // it must be a simple text search
        this.router.navigate(["search", val.value.search]);
      } else {
               // its a single file
               this.router.navigate([
                 "search",
                 val.value.search.id
               ]);
             }


    }
  }

  displayFn(optionObj?: any): Category | any | undefined {
    return optionObj ? optionObj.title : undefined;
  }

  initiateSearch(){

  }

  valueRemapped(value:any){
    return (value && value.title )?value.title : null;
  }

  freeControlChange(event: MatSlideToggleChange){

    this.cs.setFreeControlSubject(event.checked);
  }

  recentControlChange(event: MatSlideToggleChange){
    this.cs.setRecentControlSubject(event.checked);
  }

  onEnterLicense(event): void{
//    console.log('onEnterLicense');
    this.cs.setLicenseModalControlSubject({message: '', config: this.configurationService.getConfigurationCache()});
  }

  reloadPage(): void{
    location.reload(true);
  }


}



// WEBPACK FOOTER //
// ./src/app/tool-bar/tool-bar.component.ts